module.exports = __webpack_public_path__ + "img/logo_blanc.19fdf3d3.png";